import React from 'react';
import Isvg from 'react-inlinesvg';
import {
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';

import CrossIcon from 'app/images/icons/cross.svg';

interface IIconModal {
  title?: string;
  description?: string;
  buttonText?: string;
  isOpen?: boolean;
  isLoading?: boolean;
  handleSubmit: any;
  handleCancel: any;
  hasSaved: boolean;
  hasFailedValidation: boolean;
  hasFailed: boolean;
  btnClassName: string;
  icon: any;
}

export default class IconModal extends React.PureComponent<IIconModal> {
  static defaultProps: IIconModal = {
    title: 'Delete Confirmation',
    description: 'Are you sure you want to delete?',
    buttonText: 'Delete',
    handleSubmit: undefined,
    handleCancel: undefined,
    isOpen: false,
    hasSaved: false,
    hasFailedValidation: false,
    hasFailed: false,
    btnClassName: 'btn-1',
  };

  render(): React.ReactNode {
    return (
      <Modal isOpen={this.props.isOpen}>
        <div className="modal-icon">
          <Isvg src={this.props.icon} />
        </div>
        <a onClick={this.props.handleCancel} className="modal-close-button">
          <Isvg src={CrossIcon} className="modal-close-icon" />
        </a>
        <ModalHeader>{this.props.title}</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col">{this.props.children}</div>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}
